// Ported from microsites/womens-conference/src/components/LunchPicker.tsx;
// the pick is a prop and a callback instead of the microsite's mock store.
import { CatererCredit, LunchThumb } from './Lunch';
import { useMeals } from './MealsProvider';

/**
 * Lunch is a capped choice like a breakout, so it gets the same radio
 * treatment (and, one day, the same capacity machinery so caterers can cap
 * per option). Optimistic and local, same contract as the breakout picker.
 *
 * Each row wears the caterer's photo of the actual item, because "Turkey &
 * Cheddar" is a string and a picture of the sandwich is a decision.
 */
export function LunchPicker({
  current,
  onPick,
}: {
  current: string | null;
  /** Saves through /choices (optimistic in Schedule). */
  onPick: (value: string) => void;
}) {
  const meals = useMeals();

  return (
    <div className="flex flex-col gap-2">
      {meals.options.map((option) => {
        const mine = option.value === current;
        return (
          <button
            key={option.value}
            onClick={() => onPick(option.value)}
            className={`flex items-center justify-between gap-4 rounded-2xl border p-2.5 pr-4 text-left transition-colors ${
              mine
                ? 'border-wm-sage-800 bg-wm-sage-100'
                : 'border-wm-sage-200 bg-wm-petal hover:bg-wm-cream'
            }`}
            aria-pressed={mine}
          >
            <span className="flex items-center gap-3.5 leading-tight">
              <LunchThumb option={option} selected={mine} />
              <span>
                <span className="block text-sm font-semibold">{option.label}</span>
                <span className="text-wm-sage-500 block text-xs">
                  {option.detail}
                  {option.tags?.length ? ` · ${option.tags.join(' · ')}` : ''}
                </span>
              </span>
            </span>
            <span
              aria-hidden
              className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 ${
                mine ? 'border-wm-sage-800' : 'border-wm-sage-300'
              }`}
            >
              {mine ? <span className="bg-wm-sage-800 h-2.5 w-2.5 rounded-full" /> : null}
            </span>
          </button>
        );
      })}
      <div className="mt-1 flex flex-wrap items-center justify-between gap-x-4 gap-y-1">
        <p className="text-wm-sage-500 text-xs">Saturday's boxed lunch.</p>
        <CatererCredit caterer={meals.caterer} />
      </div>
    </div>
  );
}
